import { Constants, FilteredCreditApplication } from '@applyonline/shared'
import { useTranslation } from 'react-i18next'
import { ManageCoappButton } from '../../../../components'
import { useTrackStepReachedEvent } from '../../../../services/trackingEvents'
import { ETrackedEvents } from '../../../../types/tracking'

interface Props {
  creditApp: FilteredCreditApplication
}

const DeclinedPrequalForm = ({ creditApp }: Props) => {
  const { t } = useTranslation()

  useTrackStepReachedEvent(creditApp, ETrackedEvents.PrequalDeclined)

  return (
    <main className="general-message">
      <h4 className="subtitle">{t('common.financeApplication')}</h4>
      <form>
        <h3>
          {Constants.MerchantsThatForbidHavingCoapplicants.includes(creditApp.merchantId) &&
          creditApp.coapplicant == null
            ? t('common.refused', { forStep: t('common.prequalified') })
            : creditApp.coapplicant !== null
              ? t('common.refusedChangeCoapplicant', { forStep: t('common.prequalified') })
              : t('common.refusedAddCoapplicant', { forStep: t('common.prequalified') })}
        </h3>
        <div className="btn-group justify-end">
          <ManageCoappButton
            creditAppId={creditApp.id}
            useChangeLabel={creditApp.coapplicant !== null}
            merchantId={creditApp.merchantId}
            isHardDecline={creditApp.finalDecision.isHardDecline}
          />
        </div>
      </form>
    </main>
  )
}

export default DeclinedPrequalForm
